import { motion, AnimatePresence } from "framer-motion";

export default function StatusScreen({ open, status, message }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white p-8 rounded-2xl shadow-xl text-center w-full max-w-md"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
          >
            {/* LOADER */}
            {status === "loading" && (
              <div className="flex flex-col items-center">
                <div className="loader mb-4"></div>
                <p className="text-secondary font-semibold text-lg">{message}</p>
              </div>
            )}

            {/* SUCCESS */}
            {status === "success" && (
              <div className="flex flex-col items-center">
                <span className="text-green-600 text-6xl mb-4">✔</span>
                <p className="text-secondary font-semibold text-lg">{message}</p>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
